import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppConfig } from '../../config';
import axios from 'axios';
import { CompanyAction, AlertAction, AuthAction } from '../../actions';
import { LanguageCode, Sitemap, CountryCode, CompanyTypes } from '../../config';
import { RayForm, RayFormValidation } from '../../components/common';
import AdminCompanyDelete from './AdminCompanyDelete';
import { store } from '../../store';
import { history } from '../../history';
import { Translate as t } from '../../config/Translate';
import { ORG_HQ } from '../../config/appConstants';

const CompanyAdd = ({ company, companies, AddCompanyInfo }) => {

    const user = JSON.parse(localStorage.getItem('user'));
    // IMP-381: HQ 조직(companyInfo.org === 'HQ')이 아니면 부모 조직 선택을 필수로 강제.
    // (authcheck 의 su 런타임 판정 org==='HQ' 과 동치. FE required 는 UX 게이팅이며,
    //  실제 write-scope 강제는 BE company.create/update assertCompanyWriteScope 가 담당.)
    const isHQ = !!(user?.companyInfo && user.companyInfo.org === ORG_HQ);
    // U-08: BE company.create 는 비-su(= HQ 조직이 아닌 호출자)의 org=HQ 를 403(ORG_HQ_FORBIDDEN)으로 거절한다.
    // 고르면 반드시 실패하는 옵션이므로 HQ 조직이 아닌 호출자에게는 목록에서 뺀다. (HQ 조직 호출자는 서버가 허용 → 유지)
    const orgOptions = isHQ ? CompanyTypes : CompanyTypes.filter(x => x.code !== ORG_HQ);

    const [isAddProcess, setIsAddProcess] = useState(false);
    const [errors, setErrors] = useState([]);
    const [newcompany, setCompany] = useState({
        country: CountryCode[0].code,
        org: CompanyTypes[0].code,
        contact: {},
        owner: {}
    });

    useEffect(() => {
        if (isAddProcess) {
            history.push("/Admin/AdminCompanyList");
        }
    }, [company])

    const handleAdd = (e) => {
        const errValidate = RayFormValidation(form_controls, newcompany);
        if (errValidate.length > 0) {

            console.log(errValidate);

            setErrors(errValidate);
        } else {
            setIsAddProcess(true);



            AddCompanyInfo(newcompany);
        }
    }

    const handleChangeData = (e) => {
        const { name, value } = e.target;
        setCompany(newcompany => ({ ...newcompany, [name]: value }));
    }

    const form_controls = [
        {
            title: t('company.label.companyInformation'), items: [
                { type: "input", name: "name", label: t('common.field.name'), val: newcompany.name, required: true, isEditable: true },
                { type: "select", name: "country", label: t('common.field.country'), val: newcompany.country, list: CountryCode, required: true, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "select", name: "org", label: t('company.label.organization'), val: newcompany.org, list: orgOptions, required: true, isEditable: true },
                { type: "input", name: "state", label: t('common.field.state'), val: newcompany.state, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "zip", label: t('common.field.zipCode'), val: newcompany.zip, isEditable: true },
                { type: "input", name: "region", label: t('common.field.region'), val: newcompany.region, isEditable: true },
            ]
        },
        {
            title: "", items: [
                {
                    type: "combo", name: "parentCompanyId", label: t('company.field.parentCompany'),
                    val: newcompany.parentCompanyId,
                    startval: "None",
                    getCombo: () => CompanyAction.GetCombo('create'),
                    required: !isHQ,
                    isEditable: true
                },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "address", label: t('common.field.address'), val: newcompany.address, size: 12, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "addressExtra", label: t('common.field.addressExtra'), val: newcompany.addressExtra, size: 12, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "textarea", name: "note", label: t('common.field.note'), val: newcompany.note, size: 12, isEditable: true },
            ]
        },
        {
            title: t('common.label.contactInformation'), items: [
                { type: "email", name: "contactEmail", label: t('common.field.email'), val: newcompany.contactEmail, required: true, isEditable: true },
                { type: "tel", name: "contactTel", label: t('common.field.tel'), val: newcompany.contactTel, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "contactHp", label: t('common.field.mobile'), val: newcompany.contactHp, isEditable: true },
                { type: "tel", name: "contactFax", label: t('common.field.fax'), val: newcompany.contactFax, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "contactWebsite", label: t('common.field.website'), val: newcompany.contactWebsite, size: 12, isEditable: true },
            ]
        },
        {
            title: t('common.label.ownerInformation'), items: [
                { type: "input", name: "ownerName", label: t('common.field.ownerName'), val: newcompany.ownerName, isEditable: true },
                { type: "tel", name: "ownerHp", label: t('common.field.ownerMobile'), val: newcompany.ownerHp, isEditable: true },
            ]
        },
        {
            title: "", items: [
                { type: "input", name: "ownerEmail", label: t('common.field.ownerEmail'), val: newcompany.ownerEmail },
            ]
        },

    ]

    return (
        <>
            <div className="extraHeader">
                <h2 className="mb-0">{t('company.button.addNewCompany')}</h2>
                <div className="ray-right">
                    <Link to="/Admin/AdminCompanyList" className="btn btn-outline-default btn-sm mt-0 me-1">{t('common.label.list')}</Link>
                </div>
            </div>
            <div id="appCapsule" className="extra-header-active full-height">
                {!isHQ && (
                    <div className="section mt-1 mb-2">
                        <div className="alert alert-info py-2 small mb-0">🔒 {t('company.message.orgParentFixedAfterCreate')}</div>
                    </div>
                )}
                <RayForm
                    controls={form_controls}
                    isForm={true}
                    handleChangeData={handleChangeData}
                    errors={errors} />
                <div className="section">
                    <button className="btn btn-primary btn-block" onClick={() => handleAdd()}>{t('company.button.addCompany')}</button>
                </div>
            </div>
        </>
    );
};

const mapState = (state) => {
    const company = state.CompanyReducer.company;
    const companies = state.CompanyReducer.companies;
    return { company, companies };
}

const mapDispatch = dispatch => ({
    AddCompanyInfo: (data) => dispatch(CompanyAction.AddCompanyInfo(data)),
})

export default connect(mapState, mapDispatch)(CompanyAdd);
